import { useContext } from 'react';

import { HoneycombShapeContext } from '../context/honeycomb-shape.context.js';

export const useHoneycombShape = () => {
  return useContext(HoneycombShapeContext);
};
